import { render, staticRenderFns } from "./death-of-person-with-disability.vue?vue&type=template&id=16d05525&scoped=true"
import script from "./death-of-person-with-disability.vue?vue&type=script&lang=js"
export * from "./death-of-person-with-disability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d05525",
  null
  
)

export default component.exports